// import * as React from 'react';
import Switch from '@mui/material/Switch';

const label = { inputProps: { 'aria-label': 'Switch demo' } };

export default function SwitchButton({ onClick, status }) {
  return (
    <Switch {...label}
      onClick={(e) => { e.stopPropagation(); onClick(); }} checked={status === "active" ? true : false}
      sx={{
        "&.MuiSwitch-root .MuiSwitch-switchBase": {
          color: "#fff"
        },

        "&.MuiSwitch-root .Mui-checked": {
          color: "secondary.main"
        },
        "& .MuiSwitch-track": {
          backgroundColor: status === "active" ? "secondary.main" : "grey.400",
          opacity: 1,
        }
      }}

    />
  );
}